import { render, staticRenderFns } from "./deleteFile.vue?vue&type=template&id=54723ce6&scoped=true"
import script from "./deleteFile.vue?vue&type=script&lang=js"
export * from "./deleteFile.vue?vue&type=script&lang=js"
import style0 from "./deleteFile.vue?vue&type=style&index=0&id=54723ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54723ce6",
  null
  
)

export default component.exports